import { defineMessages } from 'react-intl';

export default defineMessages({
  cardTitle: {
    id: 'homeSpecimenUploadDialogMessages.cardTitle',
    defaultMessage:
      'Confermando si atterrerà in area firma e non sarà possibile modificare ulteriormente questionari e specimen di firma. Confermare la scelta?',
  },
  cancelCTA: {
    id: 'homeSpecimenUploadDialogMessages.cancelCTA',
    defaultMessage: 'Annulla',
  },
  confirmCTA: {
    id: 'homeSpecimenUploadDialogMessages.confirmCTA',
    defaultMessage: 'Conferma',
  },
});
